export default function Logo({ height = 40, withWordmark = true, light = false }) {
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
      <img
        src="/logo.png"
        alt="The Music Highway logo"
        style={{ height }}
        className={`w-auto ${light ? "bg-white rounded-xl p-1.5" : ""}`}
      />
      {withWordmark && (
        <span className="leading-tight">
          <span className={`block font-body font-extrabold text-[10px] sm:text-[11px] tracking-[0.08em] ${light ? "text-paper" : "text-ink"}`}>
            THE MUSIC HIGHWAY
          </span>
          <span className="block font-body text-[8px] sm:text-[9px] tracking-[0.32em] text-brand font-bold">
            SCHOOL OF MUSIC
          </span>
        </span>
      )}
    </span>
  );
}
